// extracted by mini-css-extract-plugin
module.exports = {"checkboxChecked":"CustomRadio_checkboxChecked__o49Ym","checkboxUnchecked":"CustomRadio_checkboxUnchecked__3WjmQ"};